/*
 * @Author: chenqing
 * @Date: 2023-07-13 17:28:37
 * @LastEditors: chenqing
 * @LastEditTime: 2023-11-03 17:16:44
 * @FilePath: /chaojimaHome/App/assets/scripts/modules/digitThreeAgriculture/index.js
 * @Description:
 */
$(function () {
  // 初始化
  initState();

  const arr = location.pathname.split('/');
  let ru = '';
  arr.forEach(item => {
    if(item.includes('.html')) {
      ru = item.split('.')[0];
    }
  })

  // tab切换
  $('.village-article-tab .tab-list .tab-list-item').on('click', function () {
    let activeId;
    const index = $('.tab-list-item').index(this) + 1;
    activeId = $('.tab-list .tab-list-item').eq(index - 1).attr('data-id');
    const arr = location.pathname.split('/');
    location.href = location.href.replace(arr[arr.length -1], activeId + '.html')
  });
});

function initState() {
  const arr = location.pathname.split('/');
  let ru = '';
  arr.forEach(item => {
    if(item.includes('.html')) {
      ru = item.split('.')[0];
    }
  })

  $('.tab-list-item').removeClass('line-hover');
  $(`.village-article-tab .tab-list .tab-list-item[data-id="${ru}"]`).addClass('line-hover');
  $('.village-tab-content .village-tab-content-detail').removeClass('show');
  $(`.village-tab-content .village-tab-content-detail[data-id="${ru}"]`).addClass('show');
}
